import React from "react";
import { Link } from "react-router-dom";
import logo from "../images/logo.png"; // Adjust the path and filename as needed
import "./Footer.css";

const Footer = () => (
  <footer className="footer-new">
    <div className="footer-main">
      <div className="footer-col">
        <img src={logo} alt="Naman Finlease Logo" className="footer-logo" />
        <h3>About Us</h3>
        <p>At Naman Finlease Pvt. Ltd, we understand that each client has unique financial needs and aspirations. Therefore, we offer personalized financial solutions tailored to our clients' requirements.</p>
      </div>
      <div className="footer-col">
        <h3>Quick Links</h3>
        <ul>
          <li><Link to="/">Home</Link></li>
          <li><Link to="/about">About Us</Link></li>
          <li><Link to="/service">Our Services</Link></li>
          <li><Link to="/career">Career</Link></li>
          <li><Link to="/contact">Contact Us</Link></li>
        </ul>
      </div>
      <div className="footer-col">
        <h3>RBI</h3>
        <ul>
          <li><Link to="/policies">Policies</Link></li>
          <li><Link to="/dla">DLA</Link></li>
          <li><a href="https://cms.rbi.org.in/" target="_blank" rel="noopener noreferrer">RBI CMS</a></li>
          <li><a href="https://sachet.rbi.org.in/" target="_blank" rel="noopener noreferrer">RBI Sachet</a></li>
          <li><Link to="/grievance-redressal">Grievance Redressal mechanism</Link></li>
        </ul>
      </div>
      <div className="footer-col">
        <h3>Contact Info</h3>
        <p>
          <b>Naman Finlease Private Limited</b><br />
          <b>CIN:</b> U70101DL1997PTC088735<br />
          S-370, Block S, Panchsheel Park South, Panchsheel Park, New Delhi, Delhi 110017<br />
          <b>RBI Reg No.:</b> N-14.01466
        </p>
        <p><b>Email</b><br/>Rajeev@namanfinlease.com<br/>nodalofficer@namanfinlease.com</p>
        <p><b>Phone Number</b><br/>9990831500</p>
      </div>
    </div>
    <div className="footer-bottom">
      &copy; {new Date().getFullYear()} Naman Finlease Pvt. Ltd. All Rights Reserved.
    </div>
  </footer>
);

export default Footer;
